import { Controller } from 'stimulus';

export default class PriceFilterController extends Controller {
  static targets = ['minInput', 'maxInput'];

  connect() {
    this.handleInput({ target: this.minInputTarget });
    this.handleInput({ target: this.maxInputTarget });
  }

  handleInput = ({ target }) => {
    target.value
      ? target.classList.add('selected')
      : target.classList.remove('selected');
  };
}
